__turbopack_context__.v({
  "Mui-disabled": "style-module-scss-module__Pp7URq__Mui-disabled",
  "Mui-focusVisible": "style-module-scss-module__Pp7URq__Mui-focusVisible",
  "Mui-selected": "style-module-scss-module__Pp7URq__Mui-selected",
  "component": "style-module-scss-module__Pp7URq__component",
  "ellipsis": "style-module-scss-module__Pp7URq__ellipsis",
  "list": "style-module-scss-module__Pp7URq__list",
  "nextButton": "style-module-scss-module__Pp7URq__nextButton",
  "prevButton": "style-module-scss-module__Pp7URq__prevButton",
  "prevNextRow": "style-module-scss-module__Pp7URq__prevNextRow",
});
